import React from 'react';
import { Drawer, Footer, InputCurrency, UploadList } from 'components';
import { useDispatch, useSelector } from 'react-redux';
import {
  closeTransfer,
  createTransfer
} from 'stores/financialEntries/financialEntryActions';
import { Button, Col, DatePicker, Divider, Form, Row } from 'antd';
import { FormItemWrap, configManager } from '@unicus/react-ui-kit';
import RemoteSelect from 'components/RemoteSelect';
import moment from 'moment';
import { normalizeFromSelect } from 'util/converters';

const FinancialEntryTransferDrawer = () => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const { saving } = useSelector((c) => c.resources['financial-entries'] ?? {});

  const handleClose = () => {
    if (!saving) {
      dispatch(closeTransfer());
    }
  };

  const handleSubmit = ({ attachments = [], ...values }) => {
    const data = {
      ...values,
      origin: normalizeFromSelect(values.origin),
      destination: normalizeFromSelect(values.destination),
      effectiveDate: moment(values.effectiveDate).format('YYYY-MM-DD'),
      attachments: attachments.map((c) => ({ attachment: c }))
    };

    dispatch(createTransfer(data));
  };

  const triggerSubmit = () => {
    form.validateFields().then(handleSubmit);
  };

  return (
    <Drawer
      title="Transferência entre contas"
      visible
      onClose={handleClose}
      size="sm"
      footer={
        <Footer>
          <Button onClick={handleClose}>Voltar</Button>
          <Button type="primary" onClick={triggerSubmit} loading={saving}>
            Salvar
          </Button>
        </Footer>
      }
    >
      <Form
        {...configManager.getConfig().layout.form}
        form={form}
        initialValues={{ attachments: [] }}
      >
        <Row>
          <Col span={12}>
            <FormItemWrap name="origin" label="Origem" required autoFocus>
              <RemoteSelect resource="checking-accounts" />
            </FormItemWrap>
          </Col>
          <Col span={12}>
            <FormItemWrap name="destination" label="Destino" required>
              <RemoteSelect resource="checking-accounts" />
            </FormItemWrap>
          </Col>
        </Row>
        <Row>
          <Col span={12}>
            <FormItemWrap
              name="effectiveDate"
              label="Data transferência"
              required
            >
              <DatePicker
                format="DD/MM/YYYY"
                disabledDate={(date) => date.isAfter(moment(), 'day')}
              />
            </FormItemWrap>
          </Col>

          <Col span={12}>
            <FormItemWrap
              className="ant-form-item-money"
              name="amount"
              label="Valor"
              required
            >
              <InputCurrency />
            </FormItemWrap>
          </Col>
        </Row>

        <Divider orientation="left">Anexos</Divider>
        <FormItemWrap name="attachments" shouldUpdate={() => false}>
          <UploadList showRemove />
        </FormItemWrap>
      </Form>
    </Drawer>
  );
};

export default FinancialEntryTransferDrawer;
